import React from 'react'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import utils from '../../../utils/index'
import LtsMultiselectUnidade from '../../../components/lottus/lts-multiselect-unidade'

/**
 * noAgendamento: o formulario dentro do dialogo de agendamento (AgendarRelatorioDialog), sem as datas (que la vao
 * para a grade de formulas) e sem seguir a unidade escolhida no topo.
 */
export const ConsultaBaixaRelatorioForm = (props) => {
  const record = props.record
  const changeHandler = props.changeHandler

  return (
    <div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <LtsMultiselectUnidade
                  name="unidade"
                  label="Unidade"
                  value={record.unidade}
                  onChange={(e) => props.onChangeUnit(e)}
                  ignorarUnidadeDoTopo={props.noAgendamento}
                />
              </div>
            </div>
            {!props.noAgendamento && (
              <div className="p-grid form-group">
                <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                  <label className="label">Pagamento: De</label>
                  <LtsCalendar
                    yearNavigator={true}
                    yearRange={utils.getYearRangeFromDate('1900')}
                    monthNavigator={true}
                    value={record.dataInicial}
                    onChangeEvento={changeHandler}
                    name="dataInicial"
                  />
                </div>
                <div className="p-col-5 p-sm-4 p-md-2 p-lg-2 p-xl-2">
                  <label className="label">Até</label>
                  <LtsCalendar
                    yearNavigator={true}
                    yearRange={utils.getYearRangeFromDate('1900')}
                    monthNavigator={true}
                    value={record.dataFinal}
                    onChangeEvento={changeHandler}
                    name="dataFinal"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
